"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _connect = _interopRequireDefault(require("@revenuejuice/editor-client-js/dist/production/connect"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ProviderAbCloudResolver =
/*#__PURE__*/
function (_Component) {
  _inherits(ProviderAbCloudResolver, _Component);

  _createClass(ProviderAbCloudResolver, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        abCloudResolver: this.abCloudResolverContext
      };
    }
  }]);

  function ProviderAbCloudResolver(props, context) {
    var _this;

    _classCallCheck(this, ProviderAbCloudResolver);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProviderAbCloudResolver).call(this, props, context));

    _defineProperty(_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "observeExposure", function (element) {
      var metaData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (_this.props.intersectionEvent) {
        _this.setState(_defineProperty({}, element.className, metaData));

        return _this.intersectionObserver.observe(element);
      }
    }), "intersectionCallback", function (entries) {
      if (_this.props.intersectionEvent) {
        entries.forEach(function (entry) {
          _this.props.intersectionEvent({
            isIntersecting: entry.isIntersecting,
            intersectionRatio: entry.intersectionRatio,
            metaData: _this.state[entry.target.className]
          });
        });
      }
    });

    var observeFeature = (0, _connect.default)({
      apikey: props.apikey,
      apiUrl: props.apiUrl,
      queryId: props.queryId,
      trackLatency: props.trackLatency
    });
    var observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: [0.0, 0.75]
    };
    _this.intersectionObserver = new IntersectionObserver(_this.intersectionCallback, observerOptions);
    _this.abCloudResolverContext = {
      observeFeature: observeFeature,
      exposureObserver: _this.observeExposure
    };
    return _this;
  }

  _createClass(ProviderAbCloudResolver, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.location !== nextProps.location) {
        return true;
      }

      return false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "render",
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return ProviderAbCloudResolver;
}(_react.Component);

ProviderAbCloudResolver.propTypes = {
  appId: _propTypes.default.string.isRequired,
  queryId: _propTypes.default.string.isRequired,
  apiKey: _propTypes.default.string.isRequired,
  apiUrl: _propTypes.default.string.isRequired,
  trackLatency: _propTypes.default.func,
  intersectionEvent: _propTypes.default.func,
  children: _propTypes.default.element.isRequired
};
ProviderAbCloudResolver.childContextTypes = {
  abCloudResolver: _propTypes.default.object.isRequired
};
ProviderAbCloudResolver.displayName = "ProviderAbCloudResolver"; //export default withRouter(IntersectionEvent(ProviderAbCloudResolver));

var _default = (0, _reactRouterDom.withRouter)(ProviderAbCloudResolver);

exports.default = _default;